import React from 'react'
import { connect } from 'react-redux'
import isEqual from 'lodash/isEqual'

import NaughtyBits from 'components/VRP/NaughtyBits'
import { getEventsForQuote } from 'actions/naughtyActions'
import { isLoadingInteractions } from 'selectors/appStatusSelectors'

const POLL_INTERVAL = 10000

export class Interactions extends React.Component {
  componentDidMount() {
    this.getInterations = showLoader =>
      this.props.getEventsForQuote(this.props.quoteId, showLoader)

    this.poller = setInterval(this.getInterations, POLL_INTERVAL)

    this.getInterations(true)
  }

  componentWillUnmount() {
    clearInterval(this.poller)
  }

  componentDidUpdate(prevProps) {
    !isEqual(this.props.quoteId, prevProps.quoteId) && this.getInterations(true)
  }

  render() {
    return <NaughtyBits {...this.props} noLink showNoneMessage />
  }
}

function mapStateToProps(state, op) {
  return { ...op, isLoading: isLoadingInteractions(state) }
}

export default connect(
  mapStateToProps,
  { getEventsForQuote },
)(Interactions)
